import { render, staticRenderFns } from "./CheckpointPrepNoteBlock.vue?vue&type=template&id=8add4322&scoped=true"
import script from "./CheckpointPrepNoteBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckpointPrepNoteBlock.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CheckpointPrepNoteBlock.vue?vue&type=style&index=0&id=8add4322&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8add4322",
  null
  
)

export default component.exports